import React from 'react';
import classNames from 'classnames';
import Input, { InputSize, InputType } from '@zvuk-b2b/react-uikit/ui/Input';
import { TEXTS } from '../../../texts';
import DurationEditHint from '../DurationEditHint';
import type { VideoRepeatControlProps } from './types';
import styles from '../index.module.scss';

const VideoRepeatControl: React.FC<VideoRepeatControlProps> = ({
  elementId,
  repeatCount,
  isValid,
  isErrorVisible,
  isBlockedDurationEdit,
  isDisabled,
  onBlur,
  onMouseOut,
  onChange,
}) => (
  <DurationEditHint isBlocked={isBlockedDurationEdit}>
    <Input
      elementId={elementId}
      value={String(repeatCount)}
      label={TEXTS.VIDEO_HELP_TEXT}
      size={InputSize.SMALL}
      type={InputType.NUMBER}
      maxLength={3}
      min={1}
      isDisabled={isDisabled || isBlockedDurationEdit}
      autoComplete="off"
      placeholder="1"
      labelClassName={styles.label}
      containerClassName={styles.control}
      inputClassName={classNames(styles.input, !isValid && styles.invalid)}
      forceError={isErrorVisible}
      aria-invalid={isErrorVisible}
      onChange={onChange}
      onBlur={onBlur}
      onMouseOut={onMouseOut}
    />
  </DurationEditHint>
);

export default VideoRepeatControl;
